<template>
  <AppContainer justify-center>
    <EHeroContent
      icon="qrcode"
      :title="t(useTranslationPath(callerPath, 'title'))"
      :description="t(useTranslationPath(callerPath, 'description'))"
    />
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore.js'
import { EHeroContent } from '@expansivefm/eds'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const appStore = useAppStore()

const callerPath = 'views.index'

onMounted(() => {
  appStore.$patch({ showBackButton: false })
})
</script>
